@if (product$ | async; as product) {
  <div class="container">
    @if (this.environmentalInfo) {
      <p [innerHtml]="environmentalInfo | safe: 'html'"></p>
    } @else {
      <p>{{ 'TabPanelContainer.tabs.noEnvironmentalInfo' | cxTranslate }}</p>
    }
  </div>
}
